import type { ExploreContentItemBasicInfoAllOfTwoType } from './exploreContentItemBasicInfoAllOfTwoType';

/**
 * 탐색 콘텐츠 기본 정보
 */
export type ExploreContentItemBasicInfoAllOfTwo = {
  type: ExploreContentItemBasicInfoAllOfTwoType;
};
